const LINKEDIN_CONNECTION_STATUSES = {
    CONNECTED: 'connected',
    INVITED: 'invited',
    NOT_AVAILABLE: 'notAvailable',
    LOADING: 'loading',
    NOT_CONNECTED: 'notConnected',
};

export default LINKEDIN_CONNECTION_STATUSES;
